export const SYSTEM_ROLE_OPTIONS = [
  { key: "organization_admin", name: "מנהל ארגון" },
  { key: "secretary", name: "מזכירות" },
  { key: "general_user", name: "משתמש כללי" },
] as const;
